import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Mixin from '@/helpers/mixin'
import VueRouter from 'vue-router'
import router from './router'
import './custom.css'
import {convert_timezone} from './helpers/roles'


Vue.mixin(Mixin)
Vue.use(VueRouter)
Vue.use(BootstrapVue)

Vue.config.productionTip = false

//import moment from 'moment'
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.js'

Vue.filter('formatDateTimeTZ', function(value, user_tz) {
    if (value) {
        try {
            //console.log('user tz: ' + user_tz + ' value: ' + value)
            const moment = require('moment-timezone/builds/moment-timezone-with-data-10-year-range');
            moment.tz.setDefault('America/Los_Angeles');
            let valid_tz = convert_timezone(user_tz)
            return moment.tz(value,`${valid_tz}`).format("MM/DD/YYYY hh:mm A z");
        } catch(ex) {
            console.log("exception: " + ex)
        }
        try {
            return moment(String(value)).format('MM/DD/YYYY hh:mm:ss A')
        } catch(ex) {
            console.log(ex)
        }
    }
});

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm:ss A')
    }
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    }
});

Vue.filter('previousDate', function(value) {
    if (value) {
        return moment(String(value)).subtract(1, 'days').format('MM/DD/YYYY')
    }
});

Vue.filter('nextDate', function(value) {
    if (value) {
        return moment(String(value)).add(1, 'days').format('MM/DD/YYYY')
    }
});

new Vue({
  render: h => h(App),
    router
}).$mount('#app')
